import Link from "next/link"
import useStore from "components/ui/Context"
import { memo, useEffect, useState } from "react"
import { DfAvatarLogin } from "components/ui/Icons"
import { useRouter } from "next/router"

// eslint-disable-next-line react/display-name
const Profile = memo(() => {
  const { userInfo, toggleModalLogin } = useStore()
  const { avatar, fullname } = userInfo
  const router = useRouter()
  const [isMobile, setIsMobile] = useState(false)
  const [isProfilePage, setIsProfilePage] = useState(false)
  const [defaultAvatar, setDefaultAvatar] = useState(avatar)

  const handleCheckProfilePage = () => {
    if (router.pathname === "/profile") setIsProfilePage(true)
    else setIsProfilePage(false)
  }

  useEffect(() => {
    handleCheckProfilePage()
  }, [router.pathname])

  useEffect(() => {
    setDefaultAvatar(avatar)
  }, [avatar])

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth < 1200) {
        setIsMobile(true)
      } else {
        setIsMobile(false)
      }
    }

    handleResize()

    window.addEventListener("resize", handleResize)

    return () => window.removeEventListener("resize", handleResize)
  }, [])

  // const profileLink = isMobile ? "/profile" : "/profile?tab=info"
  // const isProfilePage = router.pathname === profileLink

  return (
    <>
      {fullname ? (
        <div className="flex relative items-center">
          <div
            className={`flex items-center justify-center rounded-full overflow-hidden ${
              isProfilePage ? "avt_active" : ""
            }`}
          >
            <Link href={"/profile"} key={1} className="flex items-center max-[1199.5px]:p-0.5">
              {avatar ? (
                <img
                  className="cursor-pointer rounded-full object-cover"
                  style={{ width: isMobile ? "24px" : "44px", height: isMobile ? "24px" : "44px" }}
                  width={300}
                  height={300}
                  src={avatar}
                  onError={() =>
                    setDefaultAvatar("https://cdn-img.onlivetv.vn/dev/dd753111-bb90-43b4-bb4b-115f784f09c1.png")
                  }
                />
              ) : (
                <div className="rounded-full">
                  {fullname ? isMobile ? DfAvatarLogin : <img src="/icons/iconAvatarDefault.svg"></img> : defaultAvatar}
                </div>
              )}
            </Link>
          </div>
        </div>
      ) : (
        <div
          className="flex items-center py-2.5 px-7 bg-primary rounded-xl truncate text-base max-md:text-sm text-[#FAFAF9] font-medium cursor-pointer"
          onClick={() => toggleModalLogin()}
        >
          Đăng nhập
        </div>
      )}
    </>
  )
})
export default Profile
